import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';

export const CANONICAL_ORIGIN = 'https://gettilted.app';

export async function nativeShare({ title, text, url }) {
  if (Capacitor.isNativePlatform()) {
    try {
      await Share.share({ title, text, url, dialogTitle: title });
      return true;
    } catch (err) {
      if (err.message !== 'Share canceled') {
        console.error('Capacitor Share error:', err);
      }
      return false;
    }
  }

  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ title, text, url });
      return true;
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Web Share error:', err);
      }
      return false;
    }
  }

  return false;
}

export function canShare() {
  return Capacitor.isNativePlatform() || typeof navigator.share === 'function';
}
